
import { BlogPost } from "@/types/blog";
import { contentNeu } from "./content-neu";

export const OutdoorCoaching: BlogPost = {
  title: "Ihr Weg zu Klarheit in der Natur: Integratives Outdoor-Coaching für persönliche und strategische Entwicklung",
  metaTitle: "Outdoor-Coaching: Klarheit in der Natur finden",
  excerpt: "Fühlen Sie sich festgefahren? Suchen Sie nach neuen Perspektiven abseits des Büros? Entdecken Sie mein integratives Outdoor-Coaching für tiefgreifende Entwicklung in der Natur.",
  date: "18.09.2025",
  slug: "outdoor-coaching",
  imageUrl: "/lovable-uploads/a3926081-0524-49fd-befa-4825f953f8ee.png",
  author: 'Jörg Hörmann',
  authorTitle: 'Finanz- & Executive Coach',
  category: "Executive Coaching",
  tags: [
    'Outdoor-Coaching', 'Natur-Coaching', 'Walk & Talk', 'Führungskräfte Coaching', 
    'Persönliche Entwicklung', 'Integratives Coaching', 'Neurowissenschaftliches Coaching', 
    'Alpen Coaching', 'Rothsee Coaching', 'Business Coaching', 'Resilienz', 
    'Klarheit', 'Strategie', 'Stressreduktion', 'Entscheidungsfindung'
  ],
  metaDescription: "Integratives Outdoor-Coaching für Klarheit und strategische Entwicklung. Neurowissenschaftlich fundiert, individuell – Rothsee bis Alpen.",
  content: contentNeu
};

// This export matches what's expected in src/data/blog/index.ts
export const outdoorCoachingPost = OutdoorCoaching;
